import React from 'react';
import { Link } from 'react-router-dom';
import { USERS, USERS_STEPS } from './ConstPaths';

//import './UpdateButton.css';

//Presentational component to display a note that you are not logged in and what to do.
//Pass in an optional message fragment via props. 
function LoginNotice(props){
  const message = props.message || "To use this page, ";
  
  const login_path = USERS + "/" + USERS_STEPS.LOGIN;
  const create_path = USERS + "/" + USERS_STEPS.CREATE;

  return(
    <div className="aa-callout">
      <h4><i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> You are not logged in</h4>
      <p>{message}<Link to={login_path}>go to the login page</Link> or <Link to={create_path}>create a new account</Link>.</p>
    </div>
  );
}

export default LoginNotice;

